var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download"},[_c('van-overlay',{attrs:{"show":_vm.show}},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/images/download/bg.png"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }